import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Task 08: handle kéo thả SL/TP + tooltip 4 thông số + snap theo tick.
// Guard setPointerCapture cho jsdom (không có PointerCapture API).
import { useRef, useState } from "react";
import { useWidgetI18n } from "../../context/WidgetI18nContext";
import { roundToTick } from "./priceTicks";
import styles from "./TradingOverlays.module.css";
export function DraggableOrderHandles({ kind, price, baseQuantity, contractMultiplier = 1, accountEquity, toY, toPrice, bounds, tickSize, disabled = false, onCommit, }) {
    const { t } = useWidgetI18n();
    const [dragPrice, setDragPrice] = useState(null);
    const draggingRef = useRef(false);
    const shown = dragPrice ?? price;
    const shownY = toY(shown);
    if (shownY == null)
        return null;
    const clampedY = Math.min(bounds.bottom - 12, Math.max(bounds.top, shownY));
    const delta = shown - price;
    const ticks = tickSize > 0 ? Math.round(delta / tickSize) : 0;
    const money = delta * baseQuantity * contractMultiplier;
    const riskPercent = accountEquity > 0 ? (Math.abs(money) / accountEquity) * 100 : 0;
    const handlePointerDown = (e) => {
        if (disabled)
            return;
        e.stopPropagation();
        e.preventDefault();
        e.currentTarget.setPointerCapture?.(e.pointerId);
        draggingRef.current = true;
        setDragPrice(price);
    };
    const handlePointerMove = (e) => {
        if (!draggingRef.current || disabled)
            return;
        const raw = toPrice(e.clientY);
        if (raw == null)
            return;
        setDragPrice(roundToTick(raw, tickSize));
    };
    const handlePointerUp = (e) => {
        if (!draggingRef.current)
            return;
        draggingRef.current = false;
        try {
            if (e.currentTarget.hasPointerCapture?.(e.pointerId)) {
                e.currentTarget.releasePointerCapture(e.pointerId);
            }
        }
        catch {
            // jsdom / trình duyệt cũ: bỏ qua capture release.
        }
        const committed = dragPrice;
        setDragPrice(null);
        if (committed != null && committed !== price)
            onCommit?.(committed);
    };
    return (_jsxs("div", { className: styles.layer, "data-testid": `handle-${kind}`, children: [_jsx("div", { className: styles.dashedLine, style: { top: clampedY } }), _jsxs("div", { className: disabled ? `${styles.handle} ${styles.disabled}` : styles.handle, style: { top: clampedY }, "data-testid": `handle-grip-${kind}`, onPointerDown: handlePointerDown, onPointerMove: handlePointerMove, onPointerUp: handlePointerUp, children: ["\u25CF ", kind] }), dragPrice != null && (_jsxs("div", { className: styles.tooltip, style: { top: clampedY }, "data-testid": `handle-tooltip-${kind}`, children: [_jsxs("div", { children: [t("widget.trading.newPrice", { defaultValue: "New price" }), ": ", shown.toLocaleString("en-US")] }), _jsxs("div", { children: [ticks >= 0 ? "+" : "", ticks, " ticks"] }), _jsxs("div", { children: [money >= 0 ? "+" : "", Math.round(money).toLocaleString("en-US")] }), _jsxs("div", { children: [riskPercent.toFixed(2), "%"] })] }))] }));
}
